import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdministradoraService } from 'src/app/admihair/service/administradora.service';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { ConfirmationService, Message, SelectItem, TreeNode } from 'primeng/api';
import { NgForm } from '@angular/forms';
import { ExceptionDto } from 'src/app/admihair/api/dto/exception/exception-dto';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { Table } from 'primeng/table';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { PermissaoService } from 'src/app/admihair/service/permissao.service';
import { UsuarioPermissaoAdministradora } from 'src/app/admihair/api/dto/usuario-permissao-administradora';
import { UsuarioPermissaoAdministradoraService } from 'src/app/admihair/service/usuario-permissao-administradora.service';


@Component({
  selector: 'app-administradora-editar',
  templateUrl: './administradora-editar.component.html',
  styleUrls: ['./administradora-editar.component.scss']
})
export class AdministradoraEditarComponent implements OnInit {

  constructor(private administradoraService: AdministradoraService,
    private usuarioService: UsuarioService,
    private usuarioPermissaoAdministradoraService: UsuarioPermissaoAdministradoraService,
    private confirmationService: ConfirmationService,
    private permissaoService: PermissaoService,
    private activatedRouter: ActivatedRoute, 
    private erroService: ErroService,
  ) { }

  @ViewChild('f') form?: NgForm;
  value?: string;
  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Oper' }]; 
  messagemVisivel: boolean = false;
  
  id?: number;
  administradora?: Administradora;
  usuarios: Usuario[] = [];
  permissoes: Permissao[] = [];
  usuariosPermissoesAdministradoras: UsuarioPermissaoAdministradora[] = [];
  usuarioSelecionado?: Usuario = {};
  listaUsuarioNaoVinculados: Usuario[] =[];
  loading: boolean = false;
  exibirFormularioPermissao: boolean = false;
  progressoRequisicao: boolean = false;

  tiposBusca: SelectItem[] = [{label:'E-mail', value:0}, {label:'CPF', value:1}];
  buscaSelecionada: number = 0;
  emailConsulta?: string;
  cpfConsulta?: string;

  exibirDialogPermissao: boolean = false;
  categorias: TreeNode[] = [];
  colunasTabela: any[] = [];


  eventoAbaUsuario: string = 'LISTAR';
  idUsuarioFranquia?: number;

  @ViewChild('filter') filter!: ElementRef;


  ngOnInit(): void {
    this.carregarIdUrl();
    this.carregarAdministradoraPorId();
    this.inicializarAbaUsuario();
  }

  inicializarAbaUsuario(){
    this.carregarUsuarioAdministradora();
  }

  carregarUsuarioAdministradora(){
    this.usuarioService.listarPorAdministradoraId(this.id).subscribe({
      next: (data: Usuario[]) => {
        this.usuarios = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  listarUsuariosPermissoesPorUsuarioEAdministradora(){
    this.usuarioPermissaoAdministradoraService.listarPorUsuarioEAdministradora(this.usuarioSelecionado?.id, this.id).subscribe({
      next: (data: UsuarioPermissaoAdministradora[]) => {
        this.usuariosPermissoesAdministradoras = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  salvarPermissoes(){
    console.log(this.permissoes);
    for(const usuarioPerm of this.usuariosPermissoesAdministradoras){
      if(!usuarioPerm.id){
        this.usuarioPermissaoAdministradoraService.salvar(usuarioPerm).subscribe({
          next: (data: UsuarioPermissaoAdministradora) => {
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;      
            this.rolarTela();
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();  
          }
        });
      }
    }
  }

  selecionarPermissao(permissao?: Permissao){
    const usuarioPerm: UsuarioPermissaoAdministradora = {
      permissao: permissao,
      usuario: this.usuarioSelecionado,
      administradora: this.administradora
    };

    if(!this.usuariosPermissoesAdministradoras.some(
      u => u.permissao?.permissao === usuarioPerm.permissao?.permissao)) {
      this.usuariosPermissoesAdministradoras.push(usuarioPerm);
    }
    

  }

  listarPermissoes(){
    const tipo = 'FRANQUIA';
    this.permissaoService.listarPorTipo(tipo).subscribe({
      next: (data: Permissao[]) => {
        this.permissoes = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  editarPermissaoUsuario(usuario?: Usuario) {
    this.usuarioSelecionado = usuario;
    this.exibirFormularioPermissao = true;
    this.listarPermissoes();
    this.listarUsuariosPermissoesPorUsuarioEAdministradora();
  }

  carregarIdUrl(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }    
  }

  carregarAdministradoraPorId(){
    this.administradoraService.buscarAdminstradoraPorId(this.id).subscribe({
      next: (data: Administradora) => {
        this.administradora = data;
      },
      error: (err: any) => {
        console.log('erro buscar contrato: ', err);
      }
    });
  }

  atualizar(){
    this.progressoRequisicao = true;

    this.administradoraService.atualizar(this.administradora, this.id).subscribe({
      next: (data: Administradora) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;      
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();        
      }
    });
  }

  excluirPermissao(usuarioPerm: UsuarioPermissaoAdministradora){
      const posicao = this.usuariosPermissoesAdministradoras.indexOf(usuarioPerm)
      if(usuarioPerm.id){
        this.confirmationService.confirm({
          message: 'Tem certeza que seja excluir?',
          header: 'Confirmação',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          icon: 'pi pi-info-circle',
          accept: () => {
            this.usuarioPermissaoAdministradoraService.excluir(usuarioPerm.id).subscribe({
              next: () => {
                this.usuariosPermissoesAdministradoras.splice(posicao, 1);
              },
              error: (err: any) => {
                this.messages = this.erroService.handleErro(err);
                this.messagemVisivel = true;
                this.rolarTela();  
              }
            });
          }
        });
        
      } else {
        this.usuariosPermissoesAdministradoras.splice(posicao, 1);
      }
    
  }

  consultarPorEmail(){
    this.usuariosPermissoesAdministradoras = [];
    const tipo = 'FRANQUIA'
    if(this.buscaSelecionada === 0){
      this.usuarioService.buscarPorTipoEEmailEEmpresa(tipo, this.emailConsulta, this.administradora?.id).subscribe({
        next: (data: Usuario) => {
          console.log(data)
          this.usuarioSelecionado = data;
        },
        error: (err: any) => {
          this.usuarioSelecionado = undefined;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });

    } else if (this.buscaSelecionada === 1) {
      this.usuarioService.buscarPorTipoECpfEEmpresa(tipo, this.cpfConsulta, this.administradora?.id).subscribe({
        next: (data: Usuario) => {
          this.usuarioSelecionado = data;
        },
        error: (err: any) => {
          this.usuarioSelecionado = undefined;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    }
  }

  novoVinculo(){
    this.exibirFormularioPermissao = true;
    this.usuarioSelecionado = {};
    this.emailConsulta = '';
    this.permissoes = [];
    this.usuariosPermissoesAdministradoras = [];
  }

  cancelar(){
    this.carregarUsuarioAdministradora();
    this.exibirFormularioPermissao = false;
    this.messagemVisivel = false;
  }

  
  

  liberaCampo(item: string): boolean {
    return item ? true : false;
  }
  
 
  tratarErroApi(exceptions: ExceptionDto[]) {
    if(exceptions.length > 0){
      this.messages = [{ severity: 'error', summary: exceptions[0].requestId, detail: exceptions[0].data[0].message }];
    }
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }

  limparFormulario(){
    this.form?.reset();
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  ocultarMsg(){
    this.messagemVisivel = false;
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  // -- REFACTOR

  abaSelecionada(evento: any) {
    this.messagemVisivel = false;
    this.eventoAbaUsuario = 'LISTAR';
  }

  inserirUsuario() {
    this.eventoAbaUsuario = 'INSERIR';
  }

  trocarComponenteUsuario(event: any) {
    this.idUsuarioFranquia = event.id;
    this.eventoAbaUsuario = event.modo;
  }
  
}
